import { render, staticRenderFns } from "./roleBindTable.vue?vue&type=template&id=aff16b2a&scoped=true"
import script from "./roleBindTable.vue?vue&type=script&lang=js"
export * from "./roleBindTable.vue?vue&type=script&lang=js"
import style0 from "./roleBindTable.vue?vue&type=style&index=0&id=aff16b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff16b2a",
  null
  
)

export default component.exports